<style scoped>
    .bg-primary {
        background-color: #1a3665 !important;
    }
    .text-primary {
        color: #1a3665 !important;
    }
    .main {
        background-image: url('/img/bg-fo.png');
        background-size: cover;
    }
</style>
<template>
    <div class="min-vh-100 main">
        <div class="col-md-12 align-content-center pt-3">
            <img src="/img/logo-iapi.gif" width="270px" alt="" class="ml-3 ml-sm-3 ml-xl-0 mb-2">
            <img src="/img/ifac.png" width="120px" alt="" class=" ml-3 mb-2">
            <img src="/img/logo_cpa.png" width="120px" alt="" class="ml-3">
        </div>
        <div class="d-flex justify-content-center align-items-center mt-5">
            <div class="col-md-7 col-sm-12 col-12">
                <div class="card card-login mt-3">
                        <div class="card-header border-0">
                            <div class="card-title font-weight-bold mb-0">Data Anggota</div>
                        </div>
                    <div class="card-body table-responsive" v-if="statusData">
                        <table class="table table-striped table-bordered" style="font-size: 12px !imporant">
                            <tr>
                                <th class="bg-primary text-white">Nama Lengkap</th>
                                <td class="text-uppercase">{{ items.namaLengkap ? items.namaLengkap : '-'}}</td>
                            </tr>
                            <tr>
                                <th class="bg-primary text-white">Kategori </th>
                                <td class="text-uppercase">{{ items.namaKategori ? items.namaKategori : '-'}}</td>
                            </tr>
                            <tr>
                                <th class="bg-primary text-white">Nama KAP/Instansi</th>
                                <td class="text-uppercase">{{ items.namaKap ? items.namaKap : '-'}}</td>
                            </tr>
                            <tr>
                                <th class="bg-primary text-white">Tanggal terdaftar Sebagai Anggota</th>
                                <td class="text-uppercase">{{ items.tanggalDaftar ? items.tanggalDaftar : '-'}}</td>
                            </tr>
                            <tr>
                                <th class="bg-primary text-white">No. Registrasi IAPI</th>
                                <td class="text-uppercase">{{ items.noAnggota ? items.noAnggota : '-'}}</td>
                            </tr>
                            <tr>
                                <th class="bg-primary text-white">No. Register Negara Akuntan</th>
                                <td class="text-uppercase">{{ items.noRegistrasiAkuntanNegara ? items.noRegistrasiAkuntanNegara : '-'}}</td>
                            </tr>
                            <tr>
                                <th class="bg-primary text-white">No. Registrasi Izin Akuntan Publik</th>
                                <td class="text-uppercase">{{ items.noIzinAp ? items.noIzinAp : '-'}}</td>
                            </tr>
                            <tr>
                                <th class="bg-primary text-white">Masa Berlaku Kartu Anggota</th>
                                <td class="text-uppercase">{{ items.masaBerlaku ?  reverse(items.masaBerlaku) : '-' }}</td>
                            </tr>
                            <tr>
                                <th class="bg-primary text-white">Masa Berlaku Izin Akuntan Publik</th>
                                <td class="text-uppercase">5 tahun sejak {{ items.tanggalRegistrasiAp ? reverse(items.tanggalRegistrasiAp) : '-'}}</td>
                            </tr>
                            <tr>
                                <th class="bg-primary text-white">No. Sertifikat Pemegang CPA</th>
                                <td class="text-uppercase">{{ items.noSertifikat ? items.noSertifikat : '-'}}</td>
                            </tr>
                            <tr>
                                <th class="bg-primary text-white">Terdaftar di OJK</th>
                                <td class="text-uppercase">
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1" :checked="items.statusOjkBankKonvensional" disabled>
                                        <label class="form-check-label" for="inlineCheckbox1">Bank Konvensional</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1" :checked="items.statusOjkBank" disabled>
                                        <label class="form-check-label" for="inlineCheckbox1">Bank Syariah</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="checkbox" id="inlineCheckbox2" value="option2" :checked="items.statusOjkPasarModal" disabled>
                                        <label class="form-check-label" for="inlineCheckbox2">Pasar Modal</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="checkbox" id="inlineCheckbox3" value="option3" :checked="items.statusOjkIknb" disabled>
                                        <label class="form-check-label" for="inlineCheckbox3">IKNB</label>
                                    </div>
                                </td>
                                <!-- <td class="text-uppercase">{{ items.terdaftar_di_ojk ? items.terdaftar_di_ojk : '-'}}</td> -->
                            </tr>
                            
                            <tr>
                                <th class="bg-primary text-white">Terdaftar di BPK</th>
                                <td class="text-uppercase" v-if="items.terdaftar_di_bpk == 1">Ya</td>
                                <td class="text-uppercase" v-else>Tidak</td>
                            </tr>
                            <tr>
                                <th class="bg-primary text-white">Status</th>
                                <td class="text-uppercase text-success" v-if="items.statusKartuAnggota == 'Aktif'">Aktif</td>
                                <td class="text-uppercase text-danger" v-else-if="items.statusKartuAnggota == 'Tidak Aktif'">Tidak Aktif</td>
                                <td class="text-uppercase text-warning" v-else-if="items.statusKartuAnggota == 'Cuti'">Cuti</td>
                                <td class="text-uppercase text-warning" v-else-if="items.statusKartuAnggota == 'Anggota Kehormatan'">Anggota Kehormatan</td>
                                <td class="text-uppercase text-danger" v-else>Tidak Aktif</td>
                            </tr>
                            <tr>
                                <th class="bg-primary text-white">Sanksi</th>
                                <td class="" v-if="items.sanksi.length > 0">
                                    <div v-for="(val,index) in items.sanksi" :key="index">
                                        <template v-if="cekExpired(val.tanggal_mulai,val.tanggal_berakhir)">
                                            <span>Sanksi : {{ val.sanksi}}</span><br>
                                            <span>Keterangan : {{val.keterangan }}</span><br>
                                            <span>Tanggal Berlaku : {{ reformatDate(val.tanggal_mulai) +' s/d '+ reformatDate(val.tanggal_berakhir) }}</span><br>
                                            <hr>
                                        </template>
                                    </div>
                                </td>
                                <td class="text-uppercase" v-else>-</td>
                            </tr>
                        </table>
                    </div>
                    <div class="card-body" v-else>
                        <center>
                            <h4 class="text-primary font-weight-bold">Data Tidak Ditemukan !</h4>
                        </center>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="d-flex justify-content-center align-items-center flex-column min-vh-100 main">
        <div class="col-md-6">
            <div class="card">
                <div class="card-header">
                    <div class="card-title mb-0">Data Anggota</div>
                </div>
                <div class="card-body" v-if="statusData">
                    <table class="table table-striped table-bordered">
                        <tr>
                            <th class="bg-primary text-white">Nama Lengkap</th>
                            <td class="text-uppercase">{{ items.namaLengkap ? items.namaLengkap : '-'}}</td>
                        </tr>
                        <tr>
                            <th class="bg-primary text-white">Kategori Peserta</th>
                            <td class="text-uppercase">{{ items.namaKategori ? items.namaKategori : '-'}}</td>
                        </tr>
                        <tr>
                            <th class="bg-primary text-white">Nama KAP</th>
                            <td class="text-uppercase">{{ items.namaKap ? items.namaKap : '-'}}</td>
                        </tr>
                        <tr>
                            <th class="bg-primary text-white">No. Reg. IAPI</th>
                            <td class="text-uppercase">{{ items.noAnggota ? items.noAnggota : '-'}}</td>
                        </tr>
                        <tr>
                            <th class="bg-primary text-white">No. Reg. Izin</th>
                            <td class="text-uppercase">{{ items.noIzinAp ? items.noIzinAp : '-'}}</td>
                        </tr>
                    </table>
                </div>
                <div class="card-body" v-else>
                    <center>
                        <h4 class="text-primary font-weight-bold">Data Tidak Ditemukan !</h4>
                    </center>
                </div>
            </div>
        </div>
    </div> -->
</template>

<script>
import KartuAnggotaService from '@/services/web-view/kartu-anggota.service'

export default {
    data() {
        return {
            items: [],
            statusData: true,
        }
    },
    mounted() {
        this.getDetailDataKartu();
    },
    methods: {
        reverse(item) {
            var date = item;
            var newdate = date.split("-").reverse().join("/");
            return newdate;
        },
        getDetailDataKartu() {
            KartuAnggotaService.getDetailDataKartu(this.$route.params.noAnggota)
            .then(response => {
                this.items = response.data.singleData;
            })
            .catch(error => {
                this.statusData = false
                // comment console console.log(error)
            })
        }
    }
}
</script>